var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkCircleFillBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checkmark-circle-fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.2954,9.6055 L11.7274,15.6055 C11.5394,15.8525 11.2484,15.9985 10.9384,16.0005 L10.9314,16.0005 C10.6244,16.0005 10.3344,15.8585 10.1444,15.6165 L7.7124,12.5095 C7.3724,12.0755 7.4484,11.4465 7.8834,11.1065 C8.3174,10.7655 8.9474,10.8415 9.2874,11.2775 L10.9204,13.3635 L14.7044,8.3945 C15.0384,7.9555 15.6654,7.8695 16.1064,8.2045 C16.5454,8.5395 16.6304,9.1665 16.2954,9.6055 M12.0004,2.0005 C6.4774,2.0005 2.0004,6.4775 2.0004,12.0005 C2.0004,17.5225 6.4774,22.0005 12.0004,22.0005 C17.5234,22.0005 22.0004,17.5225 22.0004,12.0005 C22.0004,6.4775 17.5234,2.0005 12.0004,2.0005",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark-circle-fill",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#0068F5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircleFillBlue);
export default __webpack_public_path__ + "static/media/checkmark-circle-fill-blue.63f8bbcee7589002c307b2592f5b8def.svg";
export { ForwardRef as ReactComponent };